export const InvalidPasswordResetTokenRegex = /Invalid reset password token/;
export const WeakPasswordRegex = /PW: (?<errorMsg>.*)/;
export const IncorrectPasswordRegex = /Incorrect password/;
export const IncorrectEmailOrPasswordRegex = /Wrong email or password/;
export const EmailAddressAlreadyInUseRegex = /E-mail address already in use/;
export const InvalidBillingPostalCode = /Invalid billing postal code/;
export const InvalidBillingCountry = /Invalid billing country/;
export const UserDoesNotExistRegex = /User does not exist/;
export const ServiceAlreadyExistsRegex = /Service already exists/;
